
import Grid from '@mui/joy/Grid';
import ProjectSettings from './ProjectSettings';
import ProjectCopy from './ProjectCopy';

import useAuth from '../hooks/useAuth';


export default function NewProjectForm() {

	const { currentUser } = useAuth();
    if(!currentUser.key) {
        return null;
    }

    return (

        <Grid container>

            <Grid xs={12} sm={8} >
                <ProjectSettings />
            </Grid>
            <Grid xs={12} sm={4} >
                <ProjectCopy />
            </Grid>
          </Grid>

    );
}
